import http from "../utils/http";

function fetchGet(url) {
  return fetch(url).then(function (response) {
    //response.status表示响应的http状态码
    if (response.status === 200) {
      //json是返回的response提供的一个方法,会把返回的json字符串反序列化成对象,也被包装成一个Promise了
      return response.json();
    } else {
      return {}
    }
  })
}

export function queryNftList(weight, page, pageSize, sort) {
  return http.get("/gold/nfts?weight=" + weight + "&page=" + page + "&pageSize=" + pageSize + "&sort=" + sort,)
}

export function queryNftDetail(canister, token_id) {
  return http.get(`gold/nft?canister=${canister}&token_id=${token_id}`, {})
}

export function getRepurchaseActivities(page, pageSize) {
  return http.get(`/gold/getRepurchaseActivities?page=${page}&pageSize=${pageSize}`, {})
}

export function dailyVolume(days) {
  return http.get(`/gold/dailyVolume?days=${days}`, {})
}

export function floorPrice(days) {
  return http.get(`/gold/floorPrice?days=${days}`, {})
}



export function timeseries(days) {
  //发起get请求
  var promise = fetchGet(`https://metals-api.com/api/timeseries?access_key=pj9uxpzo9szpk9weqz3n5ny3gg0za54685al60kwsn129lz52m23nmghu19g&start_date=2012-05-01&end_date=2012-05-25&symbols=XAU`);
  return promise
}


export function getNews(days) {
  //发起get请求
  var promise = fetchGet(`https://api.marketaux.com/v1/news/all?industries=Basic%20Materials,Financial,Financial%20Services&filter_entities=true&limit=10&published_after=2023-04-18T11:17&api_token=OHhqHEFXUGBUXZQgbgIFQRroibS92Sh02i9SACUL`);
  return promise
}

export function tokens(days) {
  return http.get(`/gold/tokens`, {})
}

export function getRepurchaseNFTs() {
  return http.get(`/gold/getRepurchaseNFTs`, {})
}


